var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$store.state.patientParticipant.latestScoreDefs)?_c('div',{staticClass:"report-score-acc-aha"},[_c('div',{staticClass:"acc-risk-value"},[_vm._v("\n        "+_vm._s(_vm.risk)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }